import './Menu.scss'

import React, { Fragment, createContext, useCallback, useContext } from 'react'
import { useLocation, withRouter } from 'react-router-dom'

import Icon from '../Icon/Icon'
import classNames from 'classnames'

const ICON_SIZES = {
  "large": 32,
  "medium": 24,
  "small": 16
}

const MenuSizeContext = createContext({ menuSize: 32 })

const Menu = ({ title, size, colorfull, children }) => {
  const context = {
    menuSize: size || 'large',
    colorfull
  }

  return (
    <Fragment>
      { title &&
        <div className="menu-header">
          <div className="-indicator"></div>
          <div className="-title">{title}</div>
        </div>
      }
      <div className="menu">
        <MenuSizeContext.Provider value={context}>
          {children}
        </MenuSizeContext.Provider>
      </div>
    </Fragment>
  )
}

const MenuItem = withRouter(({ history, title, icon, link, active, onClick }) => {
  const { pathname } = useLocation()
  const { menuSize, colorfull } = useContext(MenuSizeContext)
  const _active = active || pathname.startsWith(link)
  const iconSize = ICON_SIZES[menuSize] || 32

  const _onClick = useCallback(() => {
    if (onClick) return onClick()
    if (!link) return
    history.push(link)
  }, [link, onClick, history])

  return (
    <div className={classNames("-menu-item", "-size-" + menuSize, { "-colorfull": colorfull })} onClick={_onClick}>
      <div className={classNames("-icon", { "-color-off": !_active, '-color-on': _active })}><Icon size={iconSize} icon={icon} /></div>
      <div className={classNames("-label", _active ? "label-default-medium" : "label-default-basic", { "-active": _active })}>{title}</div>
    </div>
  )
})

export default Menu
export { MenuItem }